import {Component, Element, h, Host, Prop, Watch} from '@stencil/core'
import {govHost} from '../../helpers/Dom/template'
import {GovHost} from '../../helpers/Dom/template.types'
import {validateProp} from '../../helpers/Validate/props'
import {ButtonSizes, ButtonColors, ButtonColorType} from '../gov-button/button/constants'
import {TagClass, TagSizes, TagSizesType, TagTypesType} from './constants'
import {prepareIconFormat} from "../gov-icon/helpers";

@Component({
	tag: 'gov-tag',
})
export class GovTag {
	private h: GovHost

	constructor() {
		this.h = govHost(this.host)
	}

	@Element() host: HTMLGovTagElement

	/**
	 * Definition of the button icon on the left. The icon must be defined in the form "type/name".
	 */
	@Prop({attribute: "icon-start"}) readonly iconStart?: string
	/**
	 * Definition of the button icon on the left. The icon must be defined in the form "type/name".
	 */
	@Prop({attribute: "icon-end"}) readonly iconEnd?: string
	/**
	 * Tag’s size.
	 */
	@Prop({reflect: true}) readonly size: TagSizesType = TagSizes._S
	/**
	 * Style variation of the tag.
	 */
	@Prop({reflect: true}) readonly color: ButtonColorType = ButtonColors.PRIMARY
	/**
	 * Tag’s type
	 */
	@Prop({reflect: true}) readonly type: TagTypesType
	/**
	 * Expands the tag to fill 100% of the container width
	 */
	@Prop({reflect: true}) readonly expanded: boolean = false

	@Watch('color')
	validateColor(newValue: string): void {
		validateProp(ButtonColors, newValue, TagClass.root)
	}

	@Watch('size')
	validateSize(newValue: string): void {
		validateProp(ButtonSizes, newValue, TagClass.root)
	}

	componentWillLoad(): void {
		this.validateColor(this.color)
		this.validateSize(this.size)
	}

	render() {
		const iconStart = prepareIconFormat(this.iconStart)
		const iconEnd = prepareIconFormat(this.iconEnd)
		return (
			<Host class={this.h.classes(TagClass.root)}
				color={this.color}
				size={this.size}
				type={this.type}
			>
				<span class="element">
					<slot name="icon-start">
						{iconStart && <gov-icon type={iconStart.type} name={iconStart.name}></gov-icon>}
					</slot>
					<slot/>
					<slot name="icon-end">
						{iconEnd && <gov-icon type={iconEnd.type} name={iconEnd.name}></gov-icon>}
					</slot>
				</span>
			</Host>
		)
	}
}
